import React, { FC } from 'react'
import SALink from 'components/SALink'
import styles from './ArtAdvisory.module.scss'
const TITLE = 'Take The Quiz'

const Component: FC = () => {
  return (
    <div className={styles.callout}>
      <p className={`${styles.calloutTitle} defaultTypographyH3`}>
        Not Sure What You're Looking For?
      </p>
      <p className={`${styles.calloutDescription} defaultTypographyMedium`}>
        Take a short quiz to share your preferences with our curators. They will then begin building
        a collection of works that suit your needs. A member of our team will be in touch within 1-2
        business days.
      </p>
      <SALink href='/artadvisory/brief' title={TITLE}>
        <div className={`${styles.servicesButton} defaultButtonOutlined`}>
          <p className={`${styles.buttonText} defaultTypographyCtaLarge defaultTextUppercase`}>
            {TITLE}
          </p>
        </div>
      </SALink>
    </div>
  )
}

export default Component
